import { useEffect } from 'react';
import { LicenseInfo } from '@mui/x-license-pro';
import { setHeader, setInterceptors } from './api/interceptor';
import AppRoutes from './routes';
import { Auth0Provider, AppState } from '@auth0/auth0-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { MUI_X_PRO_LICENSE_KEY } from './app/common/constants/CommonConstants';

function App() {
  const domain = process.env.REACT_APP_GLASSBOARD_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_GLASSBOARD_AUTH0_CLIENT_ID;
  const audience = process.env.REACT_APP_GLASSBOARD_AUTH0_AUDIENCE;

  if (!domain || !clientId || !audience) {
    throw new Error('Missing Auth0 environment variables');
  }

  useEffect(() => {
    setHeader();
    setInterceptors();
    LicenseInfo.setLicenseKey(MUI_X_PRO_LICENSE_KEY);
  }, []);

  const onRedirectCallback = (appState?: AppState) => {
    window.history.replaceState({}, document.title, appState?.returnTo || window.location.pathname);
  };
  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience: audience,
        redirect_uri: `${window.location.origin}/callback`
      }}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens
      useRefreshTokensFallback
      cacheLocation="localstorage"
    >
      <div className="App">
        <AppRoutes />
      </div>
    </Auth0Provider>
  );
}

export default App;
